import { EntityPage } from "@/components/EntityPage";
import { Star } from "lucide-react";

export default function Reviews() {
  const fields = [
    { key: "client_name", label: "Client name", required: true },
    { key: "rating", label: "Rating (1-5)", type: "number" },
    { key: "google_review", label: "Google Review link" },
    { key: "facebook_review", label: "Facebook Review link" },
    { key: "description", label: "Description", full: true },
  ];
  const columns = [
    { key: "client_name", label: "Client" },
    { key: "rating", label: "Rating", render: (r) => (
      <div className="flex text-amber-400">{Array.from({ length: r.rating || 0 }).map((_, i) => <Star key={i} className="w-3.5 h-3.5 fill-amber-400" />)}</div>
    )},
    { key: "google_review", label: "Google", render: (r) => r.google_review ? <a className="text-sky-400 underline text-xs" href={r.google_review} target="_blank" rel="noreferrer">Link</a> : "—" },
    { key: "facebook_review", label: "Facebook", render: (r) => r.facebook_review ? <a className="text-sky-400 underline text-xs" href={r.facebook_review} target="_blank" rel="noreferrer">Link</a> : "—" },
    { key: "description", label: "Description", render: (r) => <div className="max-w-md truncate text-muted-foreground">{r.description}</div> },
  ];
  return <EntityPage title="Reviews" subtitle="Collect Google, Facebook and internal reviews from clients." endpoint="reviews" fields={fields} columns={columns} exportFilename="reviews" />;
}
